export default class Headers {
  static AUTHORIZATION = 'X-IBE-Authorization';
}
